import { createGlobalStyle } from 'styled-components'
import { devices } from './Tool-kit/styles/mediaQueries'

export default createGlobalStyle`
*,
*::after,
*::before {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
}

html {
    scroll-behavior: smooth;
    font-size: 62.5%; //1 rem = 10px; 10px/16px = 62.5%
    background: ${({ theme }) => theme.colors.background1};
  

  
    @media ${devices.tabland} { // width < 900?
        font-size: 50%; //1 rem = 8px, 8/16 = 50%
    }

    @media ${devices.tabport} { // width < 900?
        font-size: 50%; //1 rem = 8px, 8/16 = 50%
    }

    @media ${devices.phone} { // width < 1200?
        font-size: 62.5%;  //1 rem = 9px, 9/16 = 50%
    }


}

body {
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
   
    a {
        outline: none !important;
        text-decoration: none !important;
    }

    .MuiContainer-root {
        padding: 0px !important;
    }
    
}
`
